/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-common
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

import StringResource from 'nls';
import resources from 'amdi18n-loader!./FilterResources'; // eslint-disable-line

export default new StringResource(resources);
